// extracted by mini-css-extract-plugin
export var form = "_cu-0";